'use strict';

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./cjs/react-is.production.min.js');
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/*****************
 ** WEBPACK FOOTER
 ** ./math-input/~/react-is/index.js
 ** module id = 553
 ** module chunks = 0 2
 **/